module.exports = __webpack_public_path__ + "static/media/ChakraBalancing.ed5371dd.jpg";